import { hooks as coreHooks } from 'mage-core';
import { selectors as stateSelectors } from 'mage-state';
import { useSelector } from 'react-redux';
export default function useExternalAccessibleApps() {
    const getUserAccessibleApps = useSelector(stateSelectors.getUserAccessibleApps);
    const tokenHelper = coreHooks.useTokenHelper();
    const userAccessibleApps = getUserAccessibleApps(tokenHelper);
    return userAccessibleApps.filter(app => app === null || app === void 0 ? void 0 : app.isExternalApp);
}
